import React from "react";
import {
  Form,
  Input,
  Button,
  Select,
  message,
  Row,
  Col,
  Switch,
  Checkbox,
  Space,
  Modal,
} from "antd";
import { MaintenanceFeeService, TechnicainService } from "../../../services";
import { number } from "prop-types";
import { Moment } from "../../../helpers";
import { inject, observer } from "mobx-react";
import "./style.scss";
const { Option } = Select;
const formatTime = "HH:mm";
const nowThaiYear = Moment().add(543, "years").utc(7).format("YYYY");
let uuid = 0;

@observer
class TechnicianEdit extends React.Component {
  constructor() {
    super();
    this.state = {
      keys: [],
      homes: [],
      home: {},
      projects: [],
      loadingProject: false,
      loading: false,
      disabledSelectHome: true,
      itemId: number,
      item: {},
      currentTime: "",
      defaultRateFee: 25,
      landSize: 0,
      errors: {},
      grandTotal: 0,
      listInvoiceStatus: [],
      items: [],
    };
  }
  async showMessage(msg, duration = 3) {
    return await message.success(msg, duration);
  }
  /**
   * ข้อมูลสถานะ
   */
  getStatus() {
    TechnicainService.getStatus().then((rs) => {
      if (rs) {
        const data = rs.data["data"];
        this.setState({ listInvoiceStatus: data });
      }
    });
  }

  formRef = React.createRef();

  handleSubmit = (values) => {
    const editId = this.props.editId;
    this.setState({ loading: true });
    TechnicainService.update(editId, values)
      .then((rs) => {
        if (rs) {
          let msg = rs.data["message"];
          this.setState({
            loading: false,
          });
          this.resetForm();
          this.showMessage(msg, 5);
          this.props.onCancel();
          this.props.reload();
        }
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            loading: false,
          });
        }
      });
  };

  componentWillMount() {
    const editId = this.props.editId;
    this.setState({
      itemId: this.props.itemId,
      item: this.props.item,
      projects: this.props.projects,
    });

    this.getStatus();
  }

  getItem = (id) => {
    this.setState({
      item: {},
      items: [],
    });
    console.log("get item");
    TechnicainService.view(id)
      .then((rs) => {
        if (rs) {
          this.setState({ item: rs.data["data"] });
        }
      })
      .catch((err) => this.setState({}));
  };
  onChangeProject = (value) => {
    if (value) {
      this.setState({ homes: [], disabledSelectHome: true });
    }
  };

  resetForm() {
    this.formRef.current.resetFields();
  }

  render() {
    const { item } = this.props;
    const formLayout = "horizontal";
    const formItemLayout =
      formLayout === "horizontal"
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 4 },
              md: { span: 4 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 20 },
              md: { span: 20 },
            },
          }
        : null;
    const buttonItemLayout =
      formLayout === "horizontal"
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 20, offset: 4 },
              sm: { span: 20, offset: 4 },
            },
          }
        : null;

    const listProjectItems = this.props.projects.map((item, index) => (
      <Option key={index} value={item.id}>
        {item.name}
      </Option>
    ));

    return (
      <div id="technichian-form-edit">
        <Modal
          title={item.firstname}
          open={this.props.visible}
          onCancel={() => this.props.onCancel()}
          footer=""
          centered
          bodyStyle={{ padding: "5" }}
          closable
        >
          {this.state.item ? (
            <Form
              id="formEdit"
              onFinish={this.handleSubmit}
              style={{ display: "block" }}
              ref={this.formRef}
              initialValues={{
                project_id: item.project_id,
                firstname: item.firstname,
                lastname: item.lastname,
                nickname: item.nickname,
                active: item.active,
              }}
            >
              <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                  <Form.Item
                    label="โครงการ"
                    name="project_id"
                    {...formItemLayout}
                    rules={[{ required: true, message: "เลือกโครงการ" }]}
                  >
                    <Select
                      showSearch
                      placeholder="--เลือกโครงการ--"
                      onChange={this.onChangeProject}
                      allowClear
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listProjectItems}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="ประเภท"
                    name="project_id"
                    {...formItemLayout}
                    rules={[{ required: true, message: "เลือกโครงการ" }]}
                  >
                    <Select
                      showSearch
                      placeholder="--เลือกโครงการ--"
                      onChange={this.onChangeProject}
                      allowClear
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listProjectItems}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="ชื่อ"
                    name="firstname"
                    {...formItemLayout}
                    rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
                  >
                    <Input type="text" placeholder="ชื่อ" />
                  </Form.Item>
                  <Form.Item
                    label="นามสกุล"
                    {...formItemLayout}
                    name="lastname"
                    rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
                  >
                    <Input type="text" placeholder="นามสกุล" />
                  </Form.Item>
                  <Form.Item
                    label="ชื่อเล่น"
                    {...formItemLayout}
                    name="nickname"
                    rules={[{ required: true, message: "กรุณากรอกชื่อเล่น" }]}
                  >
                    <Input type="text" placeholder="ชื่อเล่น" />
                  </Form.Item>
                  <Form.Item
                    label="สถานะ"
                    {...formItemLayout}
                    name="active"
                    rules={[
                      {
                        required: false,
                        message: "สถานะ!",
                      },
                    ]}
                  >
                    {/* <Switch defaultChecked={item.active} /> */}
                    <Input type="number"  placeholder="1=Active/0=Inactive"/>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                  <Form.Item {...buttonItemLayout}>
                    <Button type="primary" htmlType="submit" className="submit">
                      แก้ไข
                    </Button>
                    <Space />
                    <Space />
                    <Button
                      type="light"
                      htmlType="reset"
                      className="submit"
                      onClick={() => this.resetForm()}
                    >
                      รีเซ็ต
                    </Button>
                    {/* <Button onClick={() => this.getMaintenanceFee(this.state.maintenanceId)}>
              รีโหลดข้อมูล
            </Button> */}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          ) : null}
        </Modal>
      </div>
    );
  }
}

export default TechnicianEdit;
